<p-table [value]="templates">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Pipeline</th>
        <th>Created By</th>
        <th>Last Modified</th>
        <th>Is Active</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template let-i="rowIndex">
      <tr>
        <td>{{template.templateName}}</td>
        <td>{{template.producttype.name}}</td>
        <td>{{template.createdUser}}</td>
        <td>{{template.updatedDate | date: 'MM/dd/yyyy'}}</td>
        <td>{{template.isActive?answertypeConstants.Yes: answertypeConstants.No}}</td>
        <td class="action">
          <span class="btnBars p-mr-0" (click)="showEditInventoryTemplate(template)" pTooltip="Edit"
            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog header="Template - {{templateInventoryTemp?.templateName}}" [(visible)]="displayEditInventoryTemplate" [modal]="true" [responsive]="true"
  [style]="{width: '60em'}" (onHide)="hideDialog()">
  <div class="card">
    <div class="p-grid">
      <div class="p-col-12">
        <div class="p-grid">
          <h6 class="p-col p-mb-2 p-pl-4">Label Name</h6>
          <h6 class="p-col p-mb-2 p-pl-4">Edit Label Name</h6>
          <div style="width:50px" class="p-mb-2 p-text-center">
            <span class="btnBars" style="cursor: default;" pTooltip="Fields" tooltipPosition="top">
              <i class="pi pi-file" style="font-size: 15px;"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <ng-container class="p-grid" *ngIf="availableInventoryLabels_item.length>0">
      <p-table [value]="availableInventoryLabels_item" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5>{{templateSections[0] && templateSections[0].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow1(selectedInventoryCheck1)" #l1 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck1" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr  *ngIf="!label.IsHide">
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setInventorySection(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_inventory.length>0">
      <p-table [value]="availableInventoryLabels_inventory" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5 pTooltip="{{templateSections[1].name}}" tooltipPosition="top">
                {{ (templateSections[1].name.length>25)? (templateSections[1].name  | slice:0:25)+'...':(templateSections[1].name ) }}
              </h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow2(selectedInventoryCheck2)" #l2 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck2" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr  *ngIf="!label.IsHide">
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" [value]="label" [(ngModel)]="label.isChecked"
                (click)="setAttributeSection(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_sales.length>0">
      <p-table [value]="availableInventoryLabels_sales" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5 pTooltip="{{templateSections[2].name}}" tooltipPosition="top">
                {{ (templateSections[2].name.length>25)? (templateSections[2].name  | slice:0:25)+'...':(templateSections[2].name ) }}
              </h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow3(selectedInventoryCheck3)" #l3 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck3" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setSalesSection(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_price.length>0">
      <p-table [value]="availableInventoryLabels_price" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5>{{templateSections[3] && templateSections[3].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow4(selectedInventoryCheck4)" #l4 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck4" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setPriceSection(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_finance.length>0">
      <p-table [value]="availableInventoryLabels_finance" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5>{{templateSections[8] && templateSections[8].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow9(selectedInventoryCheck9)" #l5 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck9" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setWarehouseSection(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_warehouse.length>0">
      <p-table [value]="availableInventoryLabels_warehouse" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5>{{templateSections[4] && templateSections[4].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow5(selectedInventoryCheck5)" #l5 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck5" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setWarehouseSection(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_other1.length>0">
      <p-table [value]="availableInventoryLabels_other1" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5 *ngIf="!isKit">{{templateSections[5]?templateSections[5].name:isBundle?templateSections[2].name:templateSections[1].name }}</h5>
              <h5 *ngIf="isKit">{{templateSections[3].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow6(selectedInventoryCheck6)" #l6 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck6" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setOther1Section(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_other2.length>0">
      <p-table [value]="availableInventoryLabels_other2" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5 *ngIf="!isKit">{{templateSections[6]?templateSections[6].name:isBundle?templateSections[3].name:templateSections[2].name}}</h5>
              <h5 *ngIf="isKit">{{templateSections[4].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow7(selectedInventoryCheck7)" #l7 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck7" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setOther2Section(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-container *ngIf="availableInventoryLabels_other3.length>0">
      <p-table [value]="availableInventoryLabels_other3" dataKey="id" class="editable">
        <ng-template pTemplate="header">
          <tr>
            <th class="header p-col-5">
              <h5 *ngIf="!isKit">{{templateSections[7]?templateSections[7].name:isBundle?(templateSections[4] && templateSections[4].name):(templateSections[3] && templateSections[3].name)}}</h5>
              <h5 *ngIf="isKit">{{templateSections[4].name}}</h5>
            </th>
            <th class="header"></th>
            <th style="width: 50px;padding-top: 0.45rem !important;" class="p-text-center header">
              <p-checkbox (click)="selectedInventoryRow8(selectedInventoryCheck8)" #l8 ngDefaultControl
                [(ngModel)]="selectedInventoryCheck8" binary="true"></p-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-label>
          <tr>
            <td>{{label.name}}
              <span style="color: red;" *ngIf="label.isMovable == false">*</span>
            </td>
            <td pEditableColumn class="template">
              <input pInputText type="text" [(ngModel)]="label.labelname">
            </td>
            <td class="p-text-center template">
              <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setOther3Section(label.isChecked)" binary="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayEditInventoryTemplate=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton label="Save" (click)="updateInventoryTemplate(templateInventoryTemp)"></button>
  </p-footer>
</p-dialog>
